<form class="flex-column" [formGroup]="customFieldsForm">
    @for (field of customFields; track field.data.id) {
        @switch (field.data.type) {
            @case (CustomFieldTypeEnum.input) {
                <span [ngStyle]="{'color': customFieldsForm.enabled ? 'black' : 'gray'}" data-testid="order-custom-field-label-span">{{ field.data.label }}</span>

                <mat-form-field appearance="fill">
                    <mat-label></mat-label>
                    <input matInput [formControlName]="'customField_' + field.data.id" [required]="field.data.required" (change)="changeForm.emit()" data-testid="order-custom-field-input">
                </mat-form-field>
            }
            @case (CustomFieldTypeEnum.textarea) {
                <span [ngStyle]="{'color': customFieldsForm.enabled ? 'black' : 'gray'}" data-testid="order-custom-field-label-span">{{ field.data.label }}</span>

                <mat-form-field appearance="fill" >
                    <mat-label></mat-label>
                    <textarea matInput [formControlName]="'customField_' + field.data.id" [required]="field.data.required" (change)="changeForm.emit()" data-testid="order-custom-field-textarea"></textarea>
                </mat-form-field>
            }
<!--            @case (CustomFieldTypeEnum.select) {-->
<!--                <mat-form-field appearance="fill">-->
<!--                    <mat-label>{{ field.data.label }}</mat-label>-->
<!--                    <mat-select [formControlName]="'customField_' + field.data.id" [required]="field.data.required">-->
<!--                        @for (option of field.data.options; track option) {-->
<!--                            &lt;!&ndash;                                <mat-option [value]="option.value">{{ option.label }}</mat-option>&ndash;&gt;-->
<!--                        }-->
<!--                    </mat-select>-->
<!--                </mat-form-field>-->
<!--            }-->
            @case (CustomFieldTypeEnum.checkbox) {
                <mat-checkbox [formControlName]="'customField_' + field.data.id" [required]="field.data.required" (click)="changeForm.emit()">
                    {{ field.data.label }}
                </mat-checkbox>
            }
            @case (CustomFieldTypeEnum.toggle) {
                <mat-slide-toggle [formControlName]="'customField_' + field.data.id" [required]="field.data.required" (change)="changeForm.emit()">
                    {{ field.data.label }}
                </mat-slide-toggle>
            }
        }
    }
</form>
